import { createStore } from '@stencil/store';

import { EMPTY_URLS } from '../utils/utils.image-capture';

const initialState = {
  imageGroupGuid: '',
  imageUrls: EMPTY_URLS,
  requiresAllPhotos: false,
  shouldShowError: false,
};

const { state, on, onChange, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
